import React, { FC } from 'react';
import { Helmet } from '@okapi/helmet-react';
import { useSelector } from 'react-redux';
import { getSeoProperties } from 'features/page-model/ducks/get-model';

export const AnalyticsPageMeta: FC = () => {
  const { pageTitle, metakeywords, metadescription, canonicalURL } = useSelector(getSeoProperties) || {};

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="keywords" content={metakeywords ?? undefined} />
        <meta name="description" content={metadescription ?? undefined} />
        <meta property="og:title" content={metakeywords ?? undefined} />
        <meta property="og:description" content={metadescription ?? undefined} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalURL || ''} />
        <link
          href="https://cdn.lemanapro.ru/lmru/image/upload/other/favicon/favicon.ico"
          rel="shortcut icon"
          type="image/x-icon"
        />
      </Helmet>
    </>
  );
};
